import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SkipLink from "@/components/SkipLink";
import Home from "@/components/pages/Home";
import About from "@/components/pages/About";
import Media from "@/components/pages/Media";
import Gallery from "@/components/pages/Gallery";
import Repertoire from "@/components/pages/Repertoire";
import Contact from "@/components/pages/Contact";
import ScrollToTop from "@/components/ScrollToTop";
import { Toaster } from "@/components/ui/toaster";
import { SEOProvider } from "@/components/SEO";
import { LanguageProvider } from "@/context/LanguageContext";

function App() {
  return (
    <LanguageProvider>
      <SEOProvider>
        <div className="App">
          <SkipLink />
          <BrowserRouter
            future={{
              v7_startTransition: true,
              v7_relativeSplatPath: true
            }}
          >
            <ScrollToTop />
            <Header />
            <main id="main-content" tabIndex="-1">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/media" element={<Media />} />
                <Route path="/gallery" element={<Gallery />} />
                <Route path="/repertoire" element={<Repertoire />} />
                <Route path="/contact" element={<Contact />} />
              </Routes>
            </main>
            <Footer />
            <Toaster />
          </BrowserRouter>
        </div>
      </SEOProvider>
    </LanguageProvider>
  );
}

export default App;